import { useState, useEffect, useCallback } from "react";

export const CountdownTimer = ({ targetDate, compact = false }) => {
  const calculateTimeLeft = useCallback(() => {
    const now = new Date().getTime();
    const target = new Date(targetDate).getTime();
    const difference = target - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000),
      expired: false,
    };
  }, [targetDate]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  if (timeLeft.expired) {
    return (
      <div className="flex items-center justify-center gap-2 text-ignition-red font-heading font-bold uppercase tracking-wider">
        <span className="animate-pulse">LAUNCHED</span>
      </div>
    );
  }

  const formatNumber = (num) => String(num).padStart(2, "0");

  if (compact) {
    return (
      <div className="flex items-center gap-1 font-mono text-sm text-slate-300" data-testid="countdown-compact">
        {timeLeft.days > 0 && <span>{timeLeft.days}d</span>}
        <span>{formatNumber(timeLeft.hours)}h</span>
        <span>{formatNumber(timeLeft.minutes)}m</span>
        <span>{formatNumber(timeLeft.seconds)}s</span>
      </div>
    );
  }

  return (
    <div className="flex gap-2 md:gap-4 justify-center items-end" data-testid="countdown-timer">
      {timeLeft.days > 0 && (
        <div className="flex flex-col items-center">
          <div className="countdown-digit">{formatNumber(timeLeft.days)}</div>
          <span className="countdown-label">Days</span>
        </div>
      )}
      <div className="flex flex-col items-center">
        <div className="countdown-digit">{formatNumber(timeLeft.hours)}</div>
        <span className="countdown-label">Hours</span>
      </div>
      <div className="flex flex-col items-center">
        <div className="countdown-digit">{formatNumber(timeLeft.minutes)}</div>
        <span className="countdown-label">Min</span>
      </div>
      <div className="flex flex-col items-center">
        <div className="countdown-digit">{formatNumber(timeLeft.seconds)}</div>
        <span className="countdown-label">Sec</span>
      </div>
    </div>
  );
};
